<template>
  <div class="wrapper">
    <button data-modal-close @tap="cancel" @click="cancel">
      <img src="@/assets/images/close-white.svg" height="20" width="20" alt="close icon"/>
      <span class="visually-hidden">Close modal</span>
    </button>
    <div class="content">
      <div class="inner-content">
        <div class="headline">Warte! Dein Schutz ist nur einen Klick entfernt – mit 15 € Vorteil!</div>
        <div class="text">Du bist nur noch einen Schritt davon entfernt, Dein Tier optimal abzusichern.
          Sichere Dir jetzt <b>15 € Rabatt</b> und schütze Deinen Liebling vor unerwarteten Tierarztkosten.</div>
        <a-btn primary @click="done" id="seo-button-as">Jetzt abschließen & 15 € Wunschgutschein sichern</a-btn>
        <div>
          <a href="https://www.agila.de/images/pdf/AGILA_Teilnahmebedingungen_Wunschgutschein.pdf" target="_blank">Teilnahmebedingungen</a>
        </div>
      </div>
    </div>
    <div class="image" :style="{ backgroundImage: 'url(' + require('@/assets/images/exit_intent_voucher.png') + ')' }">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    healthElements: {
      type: Array,
      default: () => []
    },
    symptomElements: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
  }),
  methods: {
    done () {
      this.$emit('done', true)
    },
    cancel () {
      this.$emit('done', false)
    }
  },
  mounted () {

  }
}

</script>

<style lang="scss" scoped>
.wrapper {
  max-width: 963px;
  display: grid;
  grid-template-columns: 1fr 384px;
  grid-template-areas: "a b";
  position: relative;

  [data-modal-close] {
    right: 0;
    top: -42px;
    width: 40px;
    height: 39px;
    padding: 10px;
  }

  @media (max-width: 844px) {
    grid-template-columns: 1fr;
    grid-template-areas: "b" "a";
    max-width: 300px;
  }

  .content {
    padding: 32px;
    grid-area: a;
    display: flex;
    align-items: center;

    @media (max-width: 844px) {
      padding: 16px;
    }

    .headline {
      color: var(--agila-style-neutrals-primre-Texte, #3B3B3B);
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: 0.24px;
    }

    .text {
      padding: 16px 0;
      line-height: 24px;
      font-size: 16px;
    }

    button {
      margin: 8px 0 16px;
      height: auto;
      border-radius: 8px;
      padding: 8px 16px;
      text-transform: none;
      font-size: 16px;
      line-height: 24px;
    }

    a {
      text-decoration: underline;
    }
  }

  .image {
    background-size: cover;
    min-height: 337px;
    grid-area: b;
    @media (max-width: 844px) {
      min-height: 263px;
    }
  }

}

</style>
